import React, { useEffect, useRef, useState } from 'react';
import { AxiosClient } from '../Utils/AxiosClient';
import { useNavigate } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Button, ButtonSize, DownloadIcon, FileLinesIcon, IconButton, IconButtonSize, IconButtonType, IconPosition, Pagination, SecondaryButton, TertiaryButton, VistraLoader } from '@tricor-digital-team/vistra-design-system';
import { forwardRef } from 'react';


const ExportCSVButton = forwardRef((props, ref) => {
  return (

    <IconButton
      ref={ref}
      action={props.onClick}
      icon={DownloadIcon}
      size={IconButtonSize.Medium}
      type={IconButtonType.Regular}
      tooltip="Export Submissions CSV"
    />
  );
});
const Dashboard = () => {
  const navigate = useNavigate();
  const exportButtonRef = useRef(null);
  const [adminList, setAdminList] = useState([]);
  const [loading, setLoading] = useState(false);
  const userName = localStorage.getItem('idv_user');

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await AxiosClient.get('/listForms');
      setAdminList([...response.data]);
    } catch (error) {
      console.error('Error fetching listForms:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleExportCSV = async () => {
    try {
      const response = await AxiosClient.get('/exp', { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'text/csv' });

      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0]; // e.g., "2025-09-27"
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `form_submissions_${formattedDate}.csv`;
      link.click();
      exportButtonRef.current?.blur();
    } catch (error) {
      console.error('CSV Export failed:', error);
    }
  };

  return (
    <div className="bg-white shadow-xl rounded-2xl w-full mt-12 pt-12 pb-6 px-[104px] max-w-[1016px]">
      <div className="flex items-center text-3xl text-gray-700 font-medium">
        <span>Welcome, {userName}</span>

      </div>
      <div className="flex items-center text-base mt-6">See the list below for all the Identity verification form submission.
        <div className="ml-auto">
          {/* <ExportCSVButton onClick={handleExportCSV} ref={exportButtonRef} />
           */}


          <SecondaryButton
            icon={FileLinesIcon}
            iconPosition={IconPosition.Left}
            label="Export list as CSV"
            size={ButtonSize.Medium}
            onClick={handleExportCSV}
          />
        </div>
      </div>
      <div className="text-sm text-gray-500 mt-10 mb-2">
        Showing {adminList.length} of {adminList.length} items
      </div>
      <div class="overflow-x-auto border-t-2 border-gray-200">
        <table class="min-w-full border-collapse">
          <thead class="border-b border-gray-200">
            <tr>
              <th class="py-2 text-xs font-medium text-gray-700 text-left w-[198px] max-w-[198px]">
                <div class="p-2">Company name</div>
              </th>
              <th class="py-2 text-xs font-medium text-gray-700 text-left w-[148px] max-w-[148px]">
                <div class="p-2">Customer name</div>
              </th>
              <th class="py-2 text-xs font-medium text-gray-700 text-left w-[198px] max-w-[198px]">
                <div class="p-2">Email</div>
              </th>
              <th class="py-2 text-xs font-medium text-gray-700 text-left w-[198px] max-w-[198px]">
                <div class="p-2">Submission date</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <td colspan="4">
                <div className="h-[200px] flex items-center justify-center">
                  <VistraLoader />
                </div>
              </td>
            ) : (
              adminList.length > 0 &&
              adminList.map((item, index) => (
                <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                  <td
                    class="px-2 py-3 text-blue-500 text-sm font-medium cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis max-w-[256px]"
                    onClick={() => {
                      navigate(`/applicationDetail/${item.refCode}`);
                    }}
                  >
                    {item?.requestorInformation?.companyName}
                  </td>
                  <td class="px-2 py-3 text-gray-700 text-sm whitespace-nowrap overflow-hidden text-ellipsis max-w-[198px]">
                    {item?.requestorInformation?.name}
                  </td>
                  <td class="px-2 py-3 text-gray-700 text-sm whitespace-nowrap overflow-hidden text-ellipsis max-w-[198px]">
                    {item?.requestorInformation?.email}
                  </td>
                  <td class="px-2 py-3 text-gray-700 text-sm whitespace-nowrap overflow-hidden text-ellipsis max-w-[198px]">
                    {item?.submissionDate ? format(parseISO(item.submissionDate), 'dd MMM yyyy') : ''}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="flex justify-center items-center w-full mt-12">
          <Pagination disabled={true} currentPage={1} totalPages={1} handlePageChange={() => { }} />
        </div>
      </div>
      <div className="flex items-center mt-[72px]">
        <span className="text-sm text-gray-400">Copyright © 2025 Vistra. All Rights Reserved.</span>
        <div className="h-4 border-l border-gray-300 mx-2"></div>
        <a
          href="https://www.vistra.com/privacy-notice"
          className="text-sm text-blue-500"
          target="_blank"
          rel="noreferrer"
        >
          Privacy policy
        </a>
        <div className="h-4 border-l border-gray-300 mx-2"></div>
        <a
          href="https://www.vistra.com/idv-terms/uk"
          className="text-sm text-blue-500"
          target="_blank"
          rel="noreferrer"
        >
          Terms and conditions
        </a>
      </div>
    </div>
  );
};

export default Dashboard;
